import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { h as hasSlot } from './slot.js';

const pageHeaderCss = ":host{position:relative;box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}:host{--webkit-user-drag:none}.page-header{margin-bottom:var(--tt-spacing-lg)}.top{display:flex}.top .title{flex:1}.top .actions{display:none;align-items:center}.top .description{display:none}.has-actions .actions{display:flex;gap:var(--tt-spacing-sm)}.has-description .description{display:block}h2{font-family:var(--tt-font-default);font-size:var(--tt-font-size-xl);font-weight:var(--tt-font-weight-semibold);color:var(--tt-color-gray-900)}p{font-family:var(--tt-font-default);font-size:var(--tt-font-size-sm);font-weight:var(--tt-font-weight-regular);color:var(--tt-color-gray-900)}";

const PageHeader = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.hasDescription = false;
    this.hasActions = false;
  }
  handleSlotChange() {
    this.hasDescription = hasSlot(this.element, 'description');
    this.hasActions = hasSlot(this.element, 'actions');
  }
  connectedCallback() {
    this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  render() {
    return (
    // If the user didn't provide an ID, we'll set one so we can link tabs and tab panels with aria labels
    h("div", { part: "base", class: {
        'page-header': true,
        'has-description': this.hasDescription,
        'has-actions': this.hasActions,
      } }, h("div", { class: "top" }, h("div", { class: "title" }, h("h2", null, h("slot", null))), h("span", { part: "actions", class: "actions" }, h("slot", { onSlotchange: this.handleSlotChange, name: "actions" }))), h("span", { part: "description", class: "description" }, h("slot", { onSlotchange: this.handleSlotChange, name: "description" }))));
  }
  get element() { return this; }
  static get style() { return pageHeaderCss; }
}, [1, "tt-page-header", {
    "hasDescription": [32],
    "hasActions": [32]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-page-header"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-page-header":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, PageHeader);
      }
      break;
  } });
}

const TtPageHeader = PageHeader;
const defineCustomElement = defineCustomElement$1;

export { TtPageHeader, defineCustomElement };
